var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightDoubleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.311,
    height: 17.121,
    viewBox: "0 0 15.311 17.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M11.25,4.5l7.5,7.5-7.5,7.5m-6-15,7.5,7.5-7.5,7.5",
    transform: "translate(-4.189 -3.439)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDoubleDark);
export default __webpack_public_path__ + "static/media/chevron-right-double-dark.f8706588c8af7bcd3d2bd87e6872ac9d.svg";
export { ForwardRef as ReactComponent };